import { Component, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import SwaggerUIBundle from 'swagger-ui-dist/swagger-ui-bundle';
import * as SwaggerUIStandalonePreset from 'swagger-ui-dist/swagger-ui-standalone-preset';
import { ConfigService } from '../config.service';
import { PlatformService } from '../platform.service';

@Component({
    selector: 'app-swagger',
    templateUrl: './swagger.component.html',
    styleUrls: ['./swagger.component.css'],
    standalone: true
})
export class SwaggerComponent implements OnInit {

  constructor(
    private platform: PlatformService,
    private configService: ConfigService,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  ngOnInit(): void {
    if(this.platform.isBrowserPlatform()){
      if (!this.document.querySelector('link[href*="swagger-ui"]')) {
        const link = this.document.createElement('link');
        link.rel = 'stylesheet';
        link.href = '/assets/swagger-ui/swagger-ui.css';
        this.document.head.appendChild(link);
      }
      const platformwindow = this.platform.getWindow()
      const hostname = platformwindow.location.hostname
      // const hostname: string = 'test.alphafold.ebi.ac.uk'
      const apiKeyValue: string = 'AIzaSyCeurAJz7ZGjPQUtEaerUkBZ3TaBkXrY94';
      let url = `https://${ hostname }/api/openapi.json?key=${apiKeyValue}`;
      if(this.configService.getConfig().localEnv === 'prod'){
        url = `https://${ hostname }/api/openapi.json`;
      }

      function HideInfoUrlPlugin() {
        return {
          components: {
            InfoUrl: function() { return null }
          }
        }
      }
     
      const ui = SwaggerUIBundle({
        url: url,
        dom_id: '#swagger-ui',
        deepLinking: true,
        presets: [
          SwaggerUIBundle.presets.apis,
          SwaggerUIStandalonePreset,
        ],
        syntaxHighlight: {
          activate: true,
          theme: "nord"
        },
        plugins: [
          SwaggerUIBundle.plugins.DownloadUrl,
          HideInfoUrlPlugin
        ],
        layout: "BaseLayout",
        requestInterceptor: (req) => {
          if ('method' in req) {
            const [urlPath, urlParams] = req.url.split('?');
            const apiUrl = urlPath.replace(hostname, `${ hostname }/api`);
            const queryParams = new URLSearchParams(urlParams);
            if(this.configService.getConfig().localEnv !== 'prod'){
              queryParams.set('key', apiKeyValue);
            }
            const newParams = queryParams.toString();
  
            req.url = newParams ? `${apiUrl}?${newParams}` : apiUrl;
            // req.url =`${apiUrl}?${newParams}`;
          }
          return req;
        },
      });
    }
  }
}
